{
    "actions": {
        "page": {
            "add_beneficiary": "Add beneficiary"
        },
        "beneficiary": {
            "associate_contract": "Associate a contract",
            "update_label": "Rename",
            "delete": "Delete",
            "contracts_count_one": "contract",
            "contracts_count_other": "contracts",
            "no_legal_info": "No legal information",
            "no_beneficiaries": "No beneficiaries found",
            "dissaociate_contract": {
                "success": "Contract dissociated successfully",
                "error": "An error occured while trying to dissociate contract."
            },
            "update_color": {
                "success": "Color updated successfully",
                "error": "Failed to update color"
            }
        },
        "contract": {
            "legal_name": "Legal name",
            "merchant_name": "Merchant name"
        }
    },
    "modal": {
        "create": {
            "title": "Add beneficiary",
            "label": "Beneficiary name",
            "placeholder": "Enter the beneficiary name",
            "success": "Beneficiary added successfully",
            "error": "Failed to add beneficiary"
        },
        "delete": {
            "title": "Delete beneficiary",
            "text": "Are you sure you want to delete the following beneficiary?",
            "success": "Beneficiary deleted successfully",
            "error": "Failed to delete beneficiary"
        },
        "associate_contract": {
            "title": "Add contracts for {{benefeciary}}",
            "success": "Contracts are successfully associated.",
            "error": "Unable to update beneficiary contracts."
        },
        "update_label": {
            "title": "Update beneficiary name",
            "label": "Beneficiary name",
            "success": "Beneficiary name updated successfully",
            "error": "Failed to update beneficiary name"
        }
    }
}